import { Plus } from 'lucide-react'
import { Button, CustomerList, CustomerForm, CustomerFilters, Pagination } from '../components'
import { useCustomers } from '../hooks/useCustomers'
import { useAuth } from '../contexts/AuthContextTest'

function Customers() {
  const { user } = useAuth()

  const {
    customers,
    isLoading,
    currentPage,
    totalPages,
    totalItems,
    showModal,
    editingCustomer,
    isCreating,
    isUpdating,
    searchTerm,
    setSearchTerm,
    handleSubmit,
    handleEdit,
    handleDelete,
    handleToggleStatus,
    handleCloseModal,
    handleClearFilters,
    handlePageChange,
  } = useCustomers({}, user)

  // Check if user can create customers
  const canCreateCustomer = user?.role?.id === 1 || user?.role.id === 2 // Only Super Admin can create customers

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-4xl font-bold text-secondary-900">Customers</h1>
          <p className="mt-1 text-base text-secondary-600">
            Manage customer information and relationships
          </p>
        </div>
        {canCreateCustomer && (
          <Button
            onClick={() => handleEdit(null)}
            variant="primary"
            size="md"
          >
            <Plus className="h-4 w-4 mr-2" />
            Add Customer
          </Button>
        )}
      </div>

      {/* Filters */}
      <CustomerFilters
        searchTerm={searchTerm}
        onSearchChange={setSearchTerm}
        onClearFilters={handleClearFilters}
        totalItems={totalItems}
      />

      {/* Customer List + Pagination */}
      <div>
        <CustomerList
          customers={customers}
          isLoading={isLoading}
          onEdit={handleEdit}
          onDelete={handleDelete}
          onToggleStatus={handleToggleStatus}
          userRole={user?.role?.id}
        />
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          totalItems={totalItems}
          onPageChange={handlePageChange}
        />
      </div>

      {/* Customer Form Modal */}
      <CustomerForm
        isOpen={showModal}
        editingCustomer={editingCustomer}
        onClose={handleCloseModal}
        onSubmit={handleSubmit}
        isLoading={isCreating || isUpdating}
      />
    </div>
  )
}

export default Customers